module.exports = __webpack_public_path__ + "img/bars-solid.970dcdb3.svg";